module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('PatientHeader', {
    attrs: {
      "patient": _vm.patient,
      "carehomeid": _vm.carehomeid
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dada03d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dada03d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/pages/patient/patient.scp.html
// module id = 499
// module chunks = 0